export class Period {
  label: string;
  value: string;
  year: number;
  interval: string;
  interval_index: number;
  preparationType: string;
  fiscalYearEnd: string;
  scenario: string;
  projectionName?: string;

  // Same format as DataViewColumn.toKeyString() and the backend's persisted hidden_columns keys.
  // The backend only gives a column a projection name for Projection/Proforma scenarios, so the
  // name in the periods payload is ignored for any other scenario.
  toColumnKeyString(): string {
    const keyString = `${this.value}.${(this.preparationType ?? '').toLowerCase()}`;
    const hasProjectionName = ['projection', 'proforma'].includes((this.scenario ?? '').toLowerCase());
    return (hasProjectionName && this.projectionName) ? keyString + `.${this.projectionName}` : keyString;
  }

  deserialize(data: any): this {
    Object.assign(this, data);
    return this;
  }
}

